import scenarioImages from '../scenarioImages'

export default {
  slug: 'p21s',
  title: 'P21S',
  i18nKey: 'AutomotivePboxProducts.p21s',
  heroTitleSize: 'compact',
  images: {
    hero: require('@/assets/images/pixso-automotive-detail/p21s-hero.png'),
    description: require('@/assets/images/pixso-automotive-detail/p21s-description.jpg'),
    feature: require('@/assets/images/pixso-automotive-detail/p21s-feature.jpg')
  },
  descriptionTags: [
    { key: 'interface', image: require('@/assets/images/pixso-automotive-detail/icon-interface.svg') },
    { key: 'gnss', image: require('@/assets/images/pixso-automotive-detail/icon-gnss.svg') },
    { key: 'rtk', image: require('@/assets/images/pixso-automotive-detail/icon-rtk.svg') },
    { key: 'imu', image: require('@/assets/images/pixso-automotive-detail/icon-imu.svg') }
  ],
  featureTags: [
    { key: 'fusion', image: require('@/assets/images/pixso-automotive-detail/icon-fusion.svg') },
    { key: 'complexPositioning', image: require('@/assets/images/pixso-automotive-detail/icon-complexpositioning.svg') },
    { key: 'attitude', image: require('@/assets/images/pixso-automotive-detail/icon-attitude.svg') },
    { key: 'lowPower', image: require('@/assets/images/pixso-automotive-detail/icon-low-power.svg') }
  ],
  scenarios: [
    { key: 'tunnelFork', image: scenarioImages.tunnelFork },
    { key: 'parking', image: scenarioImages.parking },
    { key: 'overpass', image: scenarioImages.overpass },
    { key: 'urbanCanyon', image: scenarioImages.urbanCanyon },
    { key: 'complexTraffic', image: scenarioImages.complexTraffic },
    { key: 'treeLinedStreet', image: scenarioImages.treeLinedStreet }
  ],
  specTabs: [
    {
      labelKey: 'ProductSpecs.tabs.basic',
      rows: [
        { labelKey: 'ProductSpecs.rows.productModel', value: { valueKey: 'ProductSpecs.values.tbd' } },
        { labelKey: 'ProductSpecs.rows.productType', value: { valueKey: 'ProductSpecs.values.pboxNav' } },
        { labelKey: 'ProductSpecs.rows.dataInterface', value: [{ valueKey: 'ProductSpecs.values.tbd' }] },
        { labelKey: 'ProductSpecs.rows.operatingVoltage', value: { valueKey: 'ProductSpecs.values.tbd' } },
        { labelKey: 'ProductSpecs.rows.operatingTemperature', value: { valueKey: 'ProductSpecs.values.tbd' } },
        { labelKey: 'ProductSpecs.rows.protectionRating', value: { valueKey: 'ProductSpecs.values.tbd' } }
      ]
    },
    { labelKey: 'ProductSpecs.tabs.gnss', rows: [] },
    { labelKey: 'ProductSpecs.tabs.imu', rows: [] },
    { labelKey: 'ProductSpecs.tabs.navigationPerformance', rows: [] }
  ]
}
